// BasicInformation.js

import React, { useEffect, useState , useCallback } from "react";
import { useIntl } from "react-intl";
import { Grid, TextField, MenuItem,FormControlLabel ,Switch} from "@mui/material";
import useStyles from "./style";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useDropzone } from "react-dropzone";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import moment from 'moment-timezone';
//Datas
import countryCodeData from "./Data/CountryCode";
//Services
import AvailablebanksApi from "Services/Availablebanks";
import dayjs from 'dayjs';
// import { CountrySelect, StateSelect, CitySelect } from "react-country-state-city";
// import "react-country-state-city/dist/react-country-state-city.css";
import { GetCountries, GetState, GetCity } from "react-country-state-city";


const BasicInformation = ({ onRef, formikbank, driverId , setsubmitButton , setSkipButton}) => {
  const classes = useStyles();
  const intl = useIntl();
  const t = intl.formatMessage;
  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  const [accountTypes, setAccountTypes] = useState([]);
  const [bankList, setBankList] = useState([]);
const [isOtherBank, setIsOtherBank] = useState(false);
const [isEditable, setIsEditable] = useState(false);



 const [country, setCountry] = useState(null);
  const [currentState, setcurrentState] = useState(null);
  const [city, setCity] = useState(null);
  const [countriesList, setCountriesList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);

useEffect(() => {
  GetCountries().then((result) => setCountriesList(result));
}, []);

useEffect(() => {
  if (formikbank.values.country) {
    GetState(parseInt(formikbank.values.country)).then((result) =>
      setStateList(result)
    );
  }
}, [formikbank.values.country]);

useEffect(() => {
  if (formikbank.values.country && formikbank.values.state) {
    GetCity(
      parseInt(formikbank.values.country),
      parseInt(formikbank.values.state)
    ).then((result) => setCitiesList(result));
  }
}, [formikbank.values.country, formikbank.values.state]);
 

  setsubmitButton(true);
  setSkipButton(true);
  // Max file size

  // Get Passenger list api
  const getbanks = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        console.log('res.data-->',res?.data?.data.data)
      const accountTypesFromApi = res?.data?.data?.account_types || [];
      setAccountTypes(accountTypesFromApi);
    const fetchedBankList = res.data.data.data;  
    const customBankName = formikbank.values.bank_name;
    const customBranchCode = formikbank.values.bank_branch_code;
    const isCustomBank =
      !!customBankName &&
      !fetchedBankList.some((bank) => bank.bankName === customBankName);

    const updatedBankList = isCustomBank
      ? [
          ...fetchedBankList,
          {
            _id: "custom",
            bankName: customBankName,
            branchCode: customBranchCode || "",
          },
        ]
      : fetchedBankList;
      setBankList(updatedBankList || []);

      }
    };
    const onFailure = (err) => { 
     console.log("error fetch service area", err);
    };
    AvailablebanksApi
      .getbanksList({ page, limit: pageSize })
      .then(onSuccess, onFailure);
  }, [page, pageSize]);

  useEffect(() => {
    getbanks();
  }, [getbanks]);  




  return (
    <>
      <FormControlLabel
  control={
    <Switch
      checked={isEditable}
      onChange={(e) => setIsEditable(e.target.checked)}
      color="primary"
    />
  }
  label={t({ id: "driver.bank.enableEdit" })}
/>
    <div className={classes.BasicInformationStyles}>
      <div style={{ opacity: isEditable ? 1 : 0.6, pointerEvents: isEditable ? 'auto' : 'none' }}>
<Grid container>
<section className={classes.container}>
<Grid item xs={12} className={classes.detailsContainer}>
  <Grid container className={classes.containerWrapper}>

 <Grid item xs={12} md={6} lg={6} xl={6}>

    <Grid container>

{/* bank acc number */}

<Grid
  item
  xs={12}
  md={12}
  lg={12}
  xl={12}
  className={classes.textFieldWrapper}
>
  <TextField
    inputProps={{
    form: {
          autocomplete: 'off',
        },
    }}
    disabled={!isEditable}
    id="bank_account_number"
    label={t({ id: "driver.bank.accountNumber" })}
    value={formikbank?.values?.bank_account_number}
    defaultValue={formikbank?.values?.bank_account_number}
    onChange={formikbank.handleChange}
    error={
      formikbank?.errors?.bank_account_number &&
      formikbank?.touched?.bank_account_number
    }
    helperText={
      formikbank?.errors?.bank_account_number &&
      formikbank?.touched?.bank_account_number &&
      formikbank?.errors?.bank_account_number
    }
    fullWidth
    variant="outlined"
    size="small"
  ></TextField>
</Grid>




<Grid
item
xs={12}
md={12}
lg={12}
xl={12}
className={classes.textFieldWrapper}
>


<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
    label={t({ id: "driver.bank.dob" })}
    value={formikbank.values.dob ? dayjs(formikbank.values.dob) : null}
    onChange={(newValue) => {
      const formattedDate = newValue ? dayjs(newValue).format('YYYY-MM-DD') : '';
      formikbank.setFieldValue('dob', formattedDate);
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        name="dob"
        id="dob"
        error={formikbank.touched.dob && Boolean(formikbank.errors.dob)}
        helperText={
          formikbank.touched.dob && formikbank.errors.dob
            ? formikbank.errors.dob
            : ''
        }
        fullWidth
        size="small"
        disabled={!isEditable}
      />
    )}
  />
</LocalizationProvider>

</Grid>

<Grid
item
xs={12}
md={12}
lg={12}
xl={12}
className={classes.textFieldWrapper}
>


<TextField
  name="sort_code"
  id="sort_code"
  label={t({ id: "driver.bank.sortCode" })}
  value={formikbank.values.sort_code}
  onChange={formikbank.handleChange}
  disabled={!isEditable} // ✅ disable if not "Other"
  error={
    formikbank.errors.sort_code && formikbank.touched.sort_code
  }
  helperText={
    formikbank.errors.sort_code &&
    formikbank.touched.sort_code &&
    formikbank.errors.sort_code
  }
  fullWidth
  variant="outlined"
  size="small"
/>

</Grid>

<Grid
item
xs={12}
md={12}
lg={12}
xl={12}
className={classes.textFieldWrapper}
>


<TextField
  name="Address"
  id="Address"
  label={t({ id: "driver.field.address" })}
  value={formikbank.values.Address}
  onChange={formikbank.handleChange}
  disabled={!isEditable} // ✅ disable if not "Other"
  error={
    formikbank.errors.Address && formikbank.touched.Address
  }
  helperText={
    formikbank.errors.Address &&
    formikbank.touched.Address &&
    formikbank.errors.Address
  }
  fullWidth
  variant="outlined"
  size="small"
/>

</Grid>
<Grid
item
xs={12}
md={12}
lg={12}
xl={12}
className={classes.textFieldWrapper}
>


<TextField
  name="postelcode"
  id="postelcode"
  label={t({ id: "driver.bank.postalCode" })}
  value={formikbank.values.postelcode}
  onChange={formikbank.handleChange}
  disabled={!isEditable} // ✅ disable if not "Other"
  error={
    formikbank.errors.postelcode && formikbank.touched.postelcode
  }
  helperText={
    formikbank.errors.postelcode &&
    formikbank.touched.postelcode &&
    formikbank.errors.postelcode
  }
  fullWidth
  variant="outlined"
  size="small"
/>

</Grid>


</Grid>
</Grid>

  <Grid item xs={12} md={6} lg={6} xl={6}>






<Grid
item
xs={12}
md={12}
lg={12}
xl={12}
className={classes.textFieldWrapper}
>


<TextField
  select
  name="country"
  id="country"
  label={t({ id: "driver.field.country" })}
  value={formikbank.values.country}
  onChange={formikbank.handleChange}
  disabled={!isEditable}
  error={Boolean(formikbank.errors.country && formikbank.touched.country)}
  helperText={
    formikbank.errors.country &&
    formikbank.touched.country &&
    formikbank.errors.country
  }
  fullWidth
  variant="outlined"
  size="small"
>
  <MenuItem value="">{t({ id: "driver.bank.selectCountry" })}</MenuItem>
  {countriesList.map((_country) => (
    <MenuItem key={_country.id} value={_country.id}>
      {_country.name}
    </MenuItem>
  ))}
</TextField>

</Grid>




<Grid
item
xs={12}
md={12}
lg={12}
xl={12}
className={classes.textFieldWrapper}
>


<TextField
  select
  name="state"
  id="state"
  label={t({ id: "driver.bank.state" })}
  value={formikbank.values.state}
  onChange={formikbank.handleChange}
  disabled={!isEditable || !formikbank.values.country} // optional: disable until country selected
  error={Boolean(formikbank.errors.state && formikbank.touched.state)}
  helperText={
    formikbank.errors.state &&
    formikbank.touched.state &&
    formikbank.errors.state
  }
  fullWidth
  variant="outlined"
  size="small"
>
  <MenuItem value="">{t({ id: "driver.bank.selectState" })}</MenuItem>
  {stateList.map((_state) => (
    <MenuItem key={_state.id} value={_state.id}>
      {_state.name}
    </MenuItem>
  ))}
</TextField>

</Grid>



<Grid
item
xs={12}
md={12}
lg={12}
xl={12}
className={classes.textFieldWrapper}
>


<TextField
  select
  name="city"
  id="city"
  label={t({ id: "driver.bank.city" })}
  value={formikbank.values.city}
  onChange={formikbank.handleChange}
  disabled={!isEditable || !formikbank.values.state} // optional: disable until state selected
  error={Boolean(formikbank.errors.city && formikbank.touched.city)}
  helperText={
    formikbank.errors.city &&
    formikbank.touched.city &&
    formikbank.errors.city
  }
  fullWidth
  variant="outlined"
  size="small"
>
  <MenuItem value="">{t({ id: "driver.bank.selectCity" })}</MenuItem>
  {citiesList.map((_city) => (
    <MenuItem key={_city.id} value={_city.id}>
      {_city.name}
    </MenuItem>
  ))}
</TextField>

</Grid>

  </Grid>

</Grid>
</Grid>
</section>
</Grid>
</div>
    </div>
    </>
  );
};

export default BasicInformation;
